const DOWNLOAD_PREFIX = /^Failed to download from: \S+ - /;
export const URL_QUERY = /(https?:\/\/[^\s?#]+)[?#]\S*/g;

// iOS Capgo prefixes ~160 chars of signed download url, which the cap would otherwise spend on.
export const describeUpdateFailure = (error: unknown, maxLength = 200): string => {
  const message = error instanceof Error ? error.message : String(error);
  return message
    .replace(DOWNLOAD_PREFIX, '')
    .replace(URL_QUERY, '$1')
    .slice(0, maxLength);
};
